import template from './communication-tool-detail.template.html';
import controller from './communication-tool-detail.controller';
import './communication-tool-detail.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool-detail/communication-tool-detail.component.js